/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SenderEnum } from './senderEnum';
import { ThemeStatusEnum } from './themeStatusEnum';
import { MailClient } from './mailClient';
import { MailUser } from './mailUser';


/**
 * Message theme
 */
export interface Theme { 
    /**
     * Id
     */
    id?: number;
    /**
     * Message theme
     */
    title?: string | null;
    /**
     * Messages count
     */
    messagesCount?: number;
    /**
     * Theme creation date
     */
    startDate?: string;
    /**
     * Last message date
     */
    lastUpdate?: string;
    status?: ThemeStatusEnum;
    initiator?: SenderEnum;
    /**
     * Readed posts count
     */
    readedPosts?: number;
    clientUser?: MailUser;
    client?: MailClient;
}

